import React from 'react';

const LoadingScreen = ({ message = 'Loading BMCL System...' }) => {
  return (
    <div className="fixed inset-0 bg-white dark:bg-gray-900 z-50 flex items-center justify-center" style={{ fontFamily: "'Noto Sans', Arial, sans-serif" }}>
      <div className="text-center">
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="w-20 h-20 border-4 border-gov-blue/20 rounded-full" />
          <div className="absolute inset-0 w-20 h-20 border-4 border-gov-blue border-t-transparent rounded-full animate-spin" />
        </div>
        <p style={{ fontSize: '15px', fontWeight: 500, color: '#6B7280' }}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
